import React, { useState } from 'react';
import { formatDateTime, formatDate } from "../../components/DateUtil";
import { Modal } from 'bootstrap';
import clientHttp from '../../components/ClientHttp';
import { useNavigate } from "react-router-dom";

export default function EBankingList({ data, totalAmount, grandTotalAmount, searchSubmit, currentPage, hasUpdatePermission }) {
    //const ORDERSTATUS = ['None','Waiting','In Process','Paid','Error']
    const ORDERSTATUS_LIST = ["Unknown", "Waiting", "In Process", "Paid", "Error", "Match", "H Process", "H Over", "H Short", "H APIErr", "H OrderErr", "O Paid", "M Paid", "AR Manual", "eVoucher Manual", "AR Auto", "eVoucher"]

    const [selectedOrder, setSelectedOrder] = useState(null)
    // mark order
    const [isSaving, setIsSaving] = useState(false)
    const [isSaveCompleted, setIsSaveCompleted] = useState(false)
    const [errorMessageClass, setErrorMessageClass] = useState('')
    const [errorMessage, setErrorMessage] = useState('')
    // clear mark order
    const [isClearing, setIsClearing] = useState(false)
    const [isClearCompleted, setIsClearCompleted] = useState(false)
    const [errorClearMessageClass, setErrorClearMessageClass] = useState('')
    const [errorClearMessage, setErrorClearMessage] = useState('')
    // history log
    const [historyLog, setHistoryLog] = useState(null);
    const [isHistoryLoading, setIsHistoryLoading] = useState(false)
    // split amount
    const [itemSplitAmount, setItemSplitAmount] = useState('')
    const [isSplit, setIsSplit] = useState(false)
    const [isSplitCompleted, setIsSplitCompleted] = useState(false)
    const [errorSplitMessage, setErrorSplitMessage] = useState('')
    const [errorSplitMessageClass, setErrorSplitMessageClass] = useState('')
    // delete order
    const [isDelete, setIsDelete] = useState(false)
    const [isDeleteCompleted, setIsDeleteCompleted] = useState(false)
    const [errorDeleteMessageClass, setErrorDeleteMessageClass] = useState('')
    const [errorDeleteMessage, setErrorDeleteMessage] = useState('')
    // special status
    const [isSpecialStatusSaving, setIsSpecialStatusSaving] = useState(false)
    const [isSpecialStatusSaveCompleted, setIsSpecialStatusSaveCompleted] = useState(false)
    const [errorSpecialStatusMessageClass, setErrorSpecialStatusMessageClass] = useState('')
    const [errorSpecialStatusMessage, setErrorSpecialStatusMessage] = useState('')

    let navigate = useNavigate()

    // input to confirm order
    //const [itemOrderId, setItemOrderId] = useState(0)
    const [itemRefCode, setItemRefCode] = useState('')
    const [itemOrderNo, setItemOrderNo] = useState('')
    const [itemTxDate, setItemTxDate] = useState('')
    const [itemComment, setItemComment] = useState('')
    const [itemByUser, setItemByUser] = useState('')
    const [orderBy, setOrderBy] = useState('order')
    const handleOrderByChange = (event) => { setOrderBy(event.target.value); console.log(event.target.value); };
    const [specialStatus, setSpecialStatus] = useState('')
    const handleSpecialStatusChange = (event) => { setSpecialStatus(event.target.value); console.log(event.target.value); };

    async function confirmOrder(order, type) {
        console.log('[confirmOrder] select order: ', order.ref1, order.ref2, order.comment)
        setSelectedOrder(order)
        // set value
        //setItemOrderId(order.id)
        setItemRefCode(order.ref1)
        setItemOrderNo(order.ref2)
        if (order.txdate !== '') {
            setItemTxDate(formatDate(new Date(order.txdate)))
        } else {
            setItemTxDate(formatDate(new Date()))
        }
        setItemComment(order.comment)
        setOrderBy(type)
        setItemByUser(localStorage.getItem('name'))
        setIsSaveCompleted(false)
        // message
        setErrorMessage('')
        setErrorMessageClass('text-danger')

        let confirmOrderForm = new Modal('#confirmOrderForm')
        confirmOrderForm.show()
    }

    async function onSave() {
        setIsSaving(true)
        setIsSaveCompleted(false)

        const formData = {
            orderId: selectedOrder.id,
            ref1: itemRefCode,
            ref2: itemOrderNo,
            txDate: itemTxDate,
            orderBy: orderBy,
            matched: selectedOrder.matched,
            comment: itemComment,
            user: localStorage.getItem('name'),
            markBy: itemByUser
        }
        console.log('call mark order api with parameters: ')
        console.log(formData)

        // call mark order api
        let token = localStorage.getItem('token')
        await clientHttp.post('onlinepayment/v1/ebanking_markorder', formData, {
            headers: { 'Authorization': 'Bearer ' + token }
        }).then(response => {
            console.log(response)
            console.log('response status: ' + response.status)
            if (response.data.status === 'success') {
                console.log('mark order success')

                setErrorMessageClass('text-success')
                setErrorMessage(response.data.message)
            } else {
                console.log('mark order failed: ' + response.data.message)
                setErrorMessage(response.data.message)
            }
        }).catch(err => {
            console.log('error: ', err.message)
            if (err.response.status === 401 || err.response.status === 403) {
                console.log('no authorize, redirect to login page')
                navigate(process.env.REACT_APP_LOGIN_URI)
            } else {
                console.log('mark order failed: ' + err.message)
                setErrorMessage(err.message)
            }
        })

        setIsSaveCompleted(true)
        setIsSaving(false)
    }

    async function clearMarkOrder(order) {
        console.log('[clearMarkOrder] select order: ', order.ref1, order.ref2)
        setSelectedOrder(order)
        setIsClearCompleted(false)
        // message
        setErrorClearMessage('')
        setErrorClearMessageClass('text-danger')

        let confirmationModal = new Modal('#confirmationModal')
        confirmationModal.show()
    }

    async function onClear() {
        setIsClearing(true)
        setIsClearCompleted(false)

        // process clear
        const formData = {
            orderId: selectedOrder.id,
            user: localStorage.getItem('name')
        }
        console.log('call clear mark api with parameters: ')
        console.log(formData)

        // call search api
        let token = localStorage.getItem('token')
        await clientHttp.post('onlinepayment/v1/ebanking_clearmark', formData, {
            headers: { 'Authorization': 'Bearer ' + token }
        }).then(response => {
            console.log(response)
            console.log('response status: ' + response.status)
            if (response.data.status === 'success') {
                console.log('clear mark order success')

                setErrorClearMessageClass('text-success')
                setErrorClearMessage(response.data.message)
            } else {
                console.log('clear mark order failed: ' + response.data.message)
                setErrorClearMessage(response.data.message)
            }
        }).catch(err => {
            console.log('error: ', err.message)
            if (err.response.status === 401 || err.response.status === 403) {
                console.log('no authorize, redirect to login page')
                navigate(process.env.REACT_APP_LOGIN_URI)
            } else {
                console.log('clear mark order failed: ' + err.message)
                setErrorClearMessage(err.message)
            }
        })

        //await new Promise( res => setTimeout(res, 1000) );
        setIsClearCompleted(true)
        setIsClearing(false)
    }

    async function viewHistoryLog(order) {
        setIsHistoryLoading(true)

        let historyLogModal = new Modal('#historyLogModal')
        historyLogModal.show()

        console.log('call history log api with parameters:' + order.id)
        const formData = {
            orderId: order.id
        }

        // call history log
        let token = localStorage.getItem('token')
        await clientHttp.post('onlinepayment/v1/ebanking_historylog', formData, {
            headers: { 'Authorization': 'Bearer ' + token }
        }).then(response => {
            setIsHistoryLoading(false)

            console.log('response status: ' + response.status)
            if (response.data.status === 'success') {
                console.log('display history log')
                setHistoryLog(response.data.data)
                //console.log(response)
            } else {
                console.log('get history log failed: ' + response.data.message)
            }

        }).catch(err => {
            setIsHistoryLoading(false)

            console.log('error: ', err.message)
            if (err.response.status === 401 || err.response.status === 403) {
                console.log('no authorize, redirect to login page')
                navigate(process.env.REACT_APP_LOGIN_URI)
            } else {
                console.log('get history log failed: ' + err.message)
            }
        })

    }

    async function confirmSplitAmount(order) {
        console.log('[confirmSplitAmount] select order: ', order.ref1, order.ref2, order.amount)
        setSelectedOrder(order)
        setItemSplitAmount('')
        setIsSplitCompleted(false)
        // message
        setErrorSplitMessage('')
        setErrorSplitMessageClass('text-danger')

        let splitAmountForm = new Modal('#splitAmountForm')
        splitAmountForm.show()
    }

    async function onSplitAmount() {
        setIsSplit(true)
        setIsSplitCompleted(false)
        setErrorSplitMessage('')

        // validate amount
        const splitAmount = parseInt(itemSplitAmount)
        const amount = parseInt(selectedOrder.amount)
        let valid = Number.isFinite(splitAmount) && splitAmount > 0
        let minorId = parseInt(selectedOrder.minorid)
        if (valid && minorId === 0 && splitAmount >= amount) {
            valid = false
        } else if (valid && minorId > 0 && splitAmount > amount) {
            valid = false
        }
        if (!valid) {
            setErrorSplitMessage('Amount is invalid')
            setIsSplit(false)
            setIsSplitCompleted(false)
            return
        }

        const formData = {
            orderId: selectedOrder.id,
            amount: itemSplitAmount,
            user: localStorage.getItem('name')
        }
        console.log('call split amount api with parameters: ')
        console.log(formData)

        // call split amount api
        let token = localStorage.getItem('token')
        await clientHttp.post('onlinepayment/v1/ebanking_splitamount', formData, {
            headers: { 'Authorization': 'Bearer ' + token }
        }).then(response => {
            console.log(response)
            console.log('response status: ' + response.status)
            if (response.data.status === 'success') {
                console.log('split amount success')

                setErrorSplitMessageClass('text-success')
                setErrorSplitMessage(response.data.message)
            } else {
                console.log('split amount failed: ' + response.data.message)
                setErrorSplitMessage(response.data.message)
            }
        }).catch(err => {
            console.log('error: ', err.message)
            if (err.response.status === 401 || err.response.status === 403) {
                console.log('no authorize, redirect to login page')
                navigate(process.env.REACT_APP_LOGIN_URI)
            } else {
                console.log('split amount failed: ' + err.message)
                setErrorSplitMessage(err.message)
            }
        })

        setIsSplit(false)
        setIsSplitCompleted(true)
    }

    async function deleteSplitAmount(order) {
        console.log('[deleteSplitAmount] select order: ', order.ref1, order.ref2)
        setSelectedOrder(order)
        setIsDeleteCompleted(false)
        // message
        setErrorDeleteMessage('')
        setErrorDeleteMessageClass('text-danger')

        let deleteSplitAmountModal = new Modal('#deleteSplitAmountModal')
        deleteSplitAmountModal.show()
    }

    async function onDeleteAmount() {
        setIsDelete(true)
        setIsDeleteCompleted(false)

        // process clear
        const formData = {
            orderId: selectedOrder.id,
            user: localStorage.getItem('name')
        }
        console.log('call delete amount api with parameters: ')
        console.log(formData)

        // call search api
        let token = localStorage.getItem('token')
        await clientHttp.post('onlinepayment/v1/ebanking_deleteamount', formData, {
            headers: { 'Authorization': 'Bearer ' + token }
        }).then(response => {
            console.log(response)
            console.log('response status: ' + response.status)
            if (response.data.status === 'success') {
                console.log('delete amount success')

                setErrorDeleteMessageClass('text-success')
                setErrorDeleteMessage(response.data.message)
            } else {
                console.log('delete amount failed: ' + response.data.message)
                setErrorDeleteMessage(response.data.message)
            }
        }).catch(err => {
            console.log('error: ', err.message)
            if (err.response.status === 401 || err.response.status === 403) {
                console.log('no authorize, redirect to login page')
                navigate(process.env.REACT_APP_LOGIN_URI)
            } else {
                console.log('delete amount failed: ' + err.message)
                setErrorDeleteMessage(err.message)
            }
        })

        //await new Promise( res => setTimeout(res, 1000) );
        setIsDeleteCompleted(true)
        setIsDelete(false)
    }

    async function confirmSpecialStatus(order) {
        console.log('[confirmSpecialStatus] select order: ', order.ref1, order.ref2)
        setSelectedOrder(order)
        // set value
        setIsSpecialStatusSaveCompleted(false)
        // message
        setErrorSpecialStatusMessage('')
        setErrorSpecialStatusMessageClass('text-danger')

        let multiActionOrderForm = new Modal('#multiActionOrderForm')
        multiActionOrderForm.show()
    }

    async function onSpecialStatusSave() {
        setIsSpecialStatusSaving(true)
        setIsSpecialStatusSaveCompleted(false)

        const formData = {
            orderId: selectedOrder.id,
            specialStatus: specialStatus,
            user: localStorage.getItem('name')
        }
        console.log('call mark order with special status api with parameters: ')
        console.log(formData)
        if (specialStatus === '') {
            setErrorSpecialStatusMessage('Type is required')
            setIsSpecialStatusSaving(false)
            return
        }

        // call mark order with special status api
        let token = localStorage.getItem('token')
        await clientHttp.post('onlinepayment/v1/ebanking_specialstatus', formData, {
            headers: { 'Authorization': 'Bearer ' + token }
        }).then(response => {
            console.log(response)
            console.log('response status: ' + response.status)
            if (response.data.status === 'success') {
                console.log('set special status order success')

                setErrorSpecialStatusMessageClass('text-success')
                setErrorSpecialStatusMessage(response.data.message)
            } else {
                console.log('set special status order failed: ' + response.data.message)
                setErrorSpecialStatusMessage(response.data.message)
            }
        }).catch(err => {
            console.log('error: ', err.message)
            if (err.response.status === 401 || err.response.status === 403) {
                console.log('no authorize, redirect to login page')
                navigate(process.env.REACT_APP_LOGIN_URI)
            } else {
                console.log('set special status order failed: ' + err.message)
                setErrorSpecialStatusMessage(err.message)
            }
        })

        setIsSpecialStatusSaveCompleted(true)
        setIsSpecialStatusSaving(false)
    }

    return (
        <>
            <div id="orderPaymentList" className="table-responsive table-hover table-sales text-nowrap">
                <table id="basic-datatables" className="table table-striped table-hover align-items-center mb-0">
                    <thead className="thead-light">
                        <tr>
                            <th scope="col">No</th>
                            <th scope="col">DateTime</th>
                            <th scope="col">Invoice No</th>
                            <th scope="col">RefCode</th>
                            <th scope="col">Order No</th>
                            <th scope="col">Payment<br />Status</th>
                            <th scope="col" className="text-end">Amount</th>
                            <th scope="col">Channel</th>
                            <th scope="col">Tx Date</th>
                            <th scope="col" className="text-center">By<br />(Order)</th>
                            <th scope="col" className="text-center">By<br />(OTSA)</th>
                            <th scope="col">Status</th>
                            <th scope="col">Comment</th>
                            <th scope="col">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            data?.map((order, index) => {
                                let isPaid = order.status === 3 || order.status > 10
                                let isByOrder = order.by_order === 1
                                let isByOTAS = order.by_otsa === 1
                                let couldManual = 'PAID' === order.branchno
                                let couldSplit = 'PAID' === order.branchno
                                let couldDelete = false
                                if (order.minorid === 0) { // major
                                    couldManual = couldManual && order.split === 1 && order.matched === 0
                                } else { // minor
                                    couldManual = couldManual && order.split === 0 && order.matched === 0
                                    couldDelete = order.split === 0 && order.matched === 0
                                }
                                let minorId = parseInt(order.minorid)
                                let isMinor = minorId > 0
                                let minorClass = isMinor ? 'text-secondary' : ''
                                let amountMinorClass = isMinor ? 'text-secondary text-end' : 'text-end'

                                return (
                                    <tr key={index}>
                                        <td className={minorClass} style={isMinor ? {"fontSize": "0.9em"} : {}}><i className="bi bi-info-circle me-0" title='Order detail'></i> {minorId === 0 ? order.majorid : order.majorid + '.' + order.minorid}</td>
                                        <td className={minorClass} style={isMinor ? {"fontSize": "0.9em"} : {}}>{formatDateTime(new Date(order.billdatetime))}</td>
                                        <td className={minorClass} style={isMinor ? {"fontSize": "0.9em"} : {}}>{order.customer}</td>
                                        <td className={minorClass} style={isMinor ? {"fontSize": "0.9em"} : {}}>{order.ref1}</td>
                                        <td className={minorClass} style={isMinor ? {"fontSize": "0.9em"} : {}}>{order.ref2}</td>
                                        <td className={minorClass} style={isMinor ? {"fontSize": "0.9em"} : {}}>{order.branchno}</td>
                                        <td className={amountMinorClass} style={isMinor ? {"fontSize": "0.9em"} : {}}>{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', currencyDisplay: 'code' })
                                            .format(order.amount).replace("USD", "").trim()}</td>
                                        <td className={minorClass} style={isMinor ? {"fontSize": "0.9em"} : {}}>{order.channel}</td>
                                        <td className={minorClass} style={isMinor ? {"fontSize": "0.9em"} : {}}>{order.txdate !== null && formatDate(new Date(order.txdate))}</td>
                                        <td className="text-center">
                                            {/* <a className="link-offset-2" href="#" onClick={confirmOrder.bind(this, order, 'Order')}>Order</a> */}
                                            {isPaid && isByOrder && <a className="text-primary small" href="#" onClick={viewHistoryLog.bind(this, order)}>{order.username}</a>}
                                            {!isPaid && couldManual && <button type="button" className="btn btn-outline-primary btn-sm" onClick={confirmOrder.bind(this, order, 'order')}>Order</button>}
                                        </td>
                                        <td className="text-center">
                                            {/* <a className="link-offset-2" href="#" onClick={confirmOrder.bind(this, order, 'OTSA')}>OTSA</a> */}
                                            {isPaid && isByOTAS && <a className="text-success small" href="#" onClick={viewHistoryLog.bind(this, order)}>{order.username}</a>}
                                            {!isPaid && couldManual && <button type="button" className="btn btn-outline-success btn-sm" onClick={confirmOrder.bind(this, order, 'otsa')}>OTSA</button>}
                                        </td>
                                        <td className={minorClass} style={isMinor ? {"fontSize": "0.9em"} : {}}>{ORDERSTATUS_LIST[order.status]}</td>
                                        <td className={minorClass} style={isMinor ? {"fontSize": "0.9em"} : {}}>{order.comment}</td>
                                        <td>
                                            {couldSplit && order.split === 1 && <><a href="#" onClick={confirmSplitAmount.bind(this, order)}><i className="bi bi-hdd-stack text-success" title='Split amount'></i> <span className="small">Split</span></a></>}
                                            {order.split === 0 && order.matched === 1 && <><a href="#" onClick={clearMarkOrder.bind(this, order)}><i className="bi bi-stars text-success" title='Clear'></i> <span className="small">Clear</span></a></>}
                                            {couldDelete && <><a href="#" onClick={deleteSplitAmount.bind(this, order)}><i className="bi bi-trash text-danger" title='Delete'></i> <span className="small text-danger">Delete</span></a></>}
                                            {!isPaid && couldManual && <a href="#" className="ms-3" onClick={confirmSpecialStatus.bind(this, order)}><i className="bi bi-check2-circle text-success" title='Mark order'></i> <span className="small">Mark</span></a>}
                                        </td>
                                    </tr>
                                )
                            })
                        }
                        <tr>
                            <td colSpan={6} className="text-end">TOTAL</td>
                            <td className="text-end">{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', currencyDisplay: 'code' })
                                .format(totalAmount).replace("USD", "").trim()}</td>
                            <td colSpan={8}></td>
                        </tr>
                        {grandTotalAmount > 0 && <tr>
                            <td colSpan={6} className="text-end">GRAND TOTAL</td>
                            <td className="text-end">{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', currencyDisplay: 'code' })
                                .format(grandTotalAmount).replace("USD", "").trim()}</td>
                            <td colSpan={8}></td>
                        </tr>}
                    </tbody>
                </table>
            </div>

            <div className="modal fade" id="confirmationModal" tabIndex="-1" aria-labelledby="confirmationModalLabel">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="confirmationModalLabel">Confirm Action</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            Do you want to clear mark of Order No. {selectedOrder?.ref2} ?

                            <p className="mt-4">
                                <span className={errorClearMessageClass}>{errorClearMessage}</span>
                            </p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-dark" data-bs-dismiss="modal" onClick={searchSubmit.bind(this, currentPage)}>Close</button>
                            {isClearing ?
                                <button className="btn btn-primary" style={{ width: '120px' }} type="button">
                                    <span className="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                    <span className="ms-3">Confirm</span>
                                </button>
                                : !isClearCompleted &&
                                <button type="button" className="btn btn-primary" style={{ width: '120px' }} onClick={onClear.bind(this)}>
                                    <i className="bi bi-check-circle"></i> Confirm
                                </button>
                            }
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="confirmOrderForm" tabIndex="-1" aria-labelledby="confirmOrderLabel">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Mark Order</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <form>
                                <div className="mb-2 row">
                                    <label className="col-sm-3 col-form-label">Order Date :</label>
                                    <div className="col-sm-9 mt-2">
                                        {formatDateTime(new Date(selectedOrder?.billdatetime))}
                                    </div>
                                </div>
                                <div className="mb-2 row">
                                    <label className="col-sm-3 col-form-label">Invoice No :</label>
                                    <div className="col-sm-9 mt-2">
                                        {selectedOrder?.customer}
                                    </div>
                                </div>
                                <div className="mb-2 row">
                                    <label className="col-sm-3 col-form-label">Amount :</label>
                                    <div className="col-sm-9 mt-2">
                                        {new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', currencyDisplay: 'code' })
                                            .format(selectedOrder?.amount).replace("USD", "").trim()}
                                    </div>
                                </div>
                                <div className="mb-2 row">
                                    <label className="col-sm-3 col-form-label">RefCode :</label>
                                    <div className="col-sm-9">
                                        <input type="text" className="form-control" value={itemRefCode} onChange={e => setItemRefCode(e.target.value)} />
                                    </div>
                                </div>
                                <div className="mb-2 row">
                                    <label className="col-sm-3 col-form-label">Order No :</label>
                                    <div className="col-sm-9">
                                        <input type="text" className="form-control" value={itemOrderNo} onChange={e => setItemOrderNo(e.target.value)} />
                                    </div>
                                </div>
                                <div className="mb-2 row">
                                    <label className="col-sm-3 col-form-label">Tx Date :</label>
                                    <div className="col-sm-9">
                                        <input type="text" className="form-control" value={itemTxDate} onChange={e => setItemTxDate(e.target.value)} />
                                    </div>
                                </div>
                                <div className="mb-2 row">
                                    <label className="col-sm-3 col-form-label">Comment :</label>
                                    <div className="col-sm-9">
                                        <input type="text" className="form-control" value={itemComment} onChange={e => setItemComment(e.target.value)} />
                                    </div>
                                </div>
                                <div className="mb-2 mt-2 row">
                                    <label className="col-sm-3 col-form-label">Type :</label>
                                    <div className="col-sm-9">
                                        <div className="input-group">
                                            <div className="form-check">
                                                <input className="form-check-input" type="radio" name="orderBy" value="order" checked={orderBy === 'order'} onChange={handleOrderByChange} /> By Order
                                            </div>
                                            <div className="form-check">
                                                <input className="form-check-input" type="radio" name="orderBy" value="otsa" checked={orderBy === 'otsa'} onChange={handleOrderByChange} /> By OTSA
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {hasUpdatePermission &&
                                    <div className="mb-2 row">
                                        <label className="col-sm-3 col-form-label">By User :</label>
                                        <div className="col-sm-9">
                                            <input type="text" className="form-control" value={itemByUser} onChange={e => setItemByUser(e.target.value)} />
                                        </div>
                                    </div>
                                }
                            </form>
                            <div className="mb-3">
                                <p className="mt-4 mb-6">
                                    <span className={errorMessageClass}>{errorMessage}</span>
                                </p>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-dark" data-bs-dismiss="modal" onClick={searchSubmit.bind(this, currentPage)}>Close</button>
                            {isSaving ?
                                <button className="btn btn-primary" style={{ width: '120px' }} type="button">
                                    <span className="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                    <span className="ms-3">Save</span>
                                </button>
                                : !isSaveCompleted &&
                                <button type="button" className="btn btn-primary" style={{ width: '120px' }} onClick={onSave.bind(this)}>
                                    <i className="bi bi-floppy"></i> Save
                                </button>
                            }
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade modal-lg" id="historyLogModal" tabIndex="-1" aria-labelledby="historyLogModalLabel">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="historyLogModalLabel">History Log</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>

                        {isHistoryLoading && (
                            <div className="d-flex justify-content-center m-5">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="sr-only">Loading...</span>
                                </div>
                            </div>
                        )}

                        {!isHistoryLoading && historyLog !== null && (
                            <div className="modal-body">
                                <table id="basic-datatables" className="table table-striped align-items-center mb-0">
                                    <thead className="thead-light">
                                        <tr>
                                            <th scope="col">DateTime</th>
                                            <th scope="col">By</th>
                                            <th scope="col">RefCode</th>
                                            <th scope="col">Order No</th>
                                            <th scope="col">Comment</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            historyLog?.map((log, index) => {
                                                return (
                                                    <tr key={index}>
                                                        <td>{formatDateTime(new Date(log.datetime))}</td>
                                                        <td>{log.username}</td>
                                                        <td>{log.ref1}</td>
                                                        <td>{log.ref2}</td>
                                                        <td>{log.comment}</td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>
                            </div>
                        )}

                        <div className="modal-footer">
                            <button type="button" className="btn btn-dark" data-bs-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="splitAmountForm" tabIndex="-1" aria-labelledby="splitAmountLabel">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Split Amount</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <form>
                                <div className="mb-2 row">
                                    <label className="col-sm-3 col-form-label">Order Date :</label>
                                    <div className="col-sm-9 mt-2">
                                        {formatDateTime(new Date(selectedOrder?.billdatetime))}
                                    </div>
                                </div>
                                <div className="mb-2 row">
                                    <label className="col-sm-3 col-form-label">Invoice No :</label>
                                    <div className="col-sm-9 mt-2">
                                        {selectedOrder?.customer}
                                    </div>
                                </div>
                                <div className="mb-2 row">
                                    <label className="col-sm-3 col-form-label">RefCode :</label>
                                    <div className="col-sm-9 mt-2">
                                        {selectedOrder?.ref1}
                                    </div>
                                </div>
                                <div className="mb-2 row">
                                    <label className="col-sm-3 col-form-label">Order No :</label>
                                    <div className="col-sm-9 mt-2">
                                        {selectedOrder?.ref2}
                                    </div>
                                </div>
                                <div className="mb-2 row">
                                    <label className="col-sm-3 col-form-label">Amount :</label>
                                    <div className="col-sm-9 mt-2">
                                        {new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', currencyDisplay: 'code' })
                                            .format(selectedOrder?.amount).replace("USD", "").trim()}
                                    </div>
                                </div>
                                <div className="mb-2 row">
                                    <label className="col-sm-3 col-form-label">Split Amount :</label>
                                    <div className="col-sm-9">
                                        <input type="text" className="form-control" value={itemSplitAmount} onChange={e => setItemSplitAmount(e.target.value)} />
                                    </div>
                                </div>
                            </form>
                            <div className="mb-3">
                                <p className="mt-4 mb-6">
                                    <span className={errorSplitMessageClass}>{errorSplitMessage}</span>
                                </p>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-dark" data-bs-dismiss="modal" onClick={searchSubmit.bind(this, currentPage)}>Close</button>
                            {isSplit ?
                                <button className="btn btn-primary" style={{ width: '120px' }} type="button">
                                    <span className="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                    <span className="ms-3">Save</span>
                                </button>
                                : !isSplitCompleted &&
                                <button type="button" className="btn btn-primary" style={{ width: '120px' }} onClick={onSplitAmount.bind(this)}>
                                    <i className="bi bi-floppy"></i> Save
                                </button>
                            }
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="deleteSplitAmountModal" tabIndex="-1" aria-labelledby="deleteSplitAmountLabel">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="deleteSplitAmountLabel">Delete Amount</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            Do you want to delete Refcode {selectedOrder?.ref1} with amount {selectedOrder?.amount.toLocaleString("en-US")} ?

                            <p className="mt-4">
                                <span className={errorDeleteMessageClass}>{errorDeleteMessage}</span>
                            </p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-dark" data-bs-dismiss="modal" onClick={searchSubmit.bind(this, currentPage)}>Close</button>
                            {isDelete ?
                                <button className="btn btn-danger" style={{ width: '120px' }} type="button">
                                    <span className="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                    <span className="ms-3">Confirm</span>
                                </button>
                                : !isDeleteCompleted &&
                                <button type="button" className="btn btn-danger" style={{ width: '120px' }} onClick={onDeleteAmount.bind(this)}>
                                    <i className="bi bi-check-circle"></i> Confirm
                                </button>
                            }
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="multiActionOrderForm" tabIndex="-1" aria-labelledby="multiActionOrderLabel">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Mark Special Status</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <form>
                                <div className="mb-2 row">
                                    <label className="col-sm-3 col-form-label">Order Date :</label>
                                    <div className="col-sm-9 mt-2">{formatDateTime(new Date(selectedOrder?.billdatetime))}</div>
                                </div>
                                <div className="mb-2 row">
                                    <label className="col-sm-3 col-form-label">Invoice No :</label>
                                    <div className="col-sm-9 mt-2">{selectedOrder?.customer}</div>
                                </div>
                                <div className="mb-2 row">
                                    <label className="col-sm-3 col-form-label">RefCode :</label>
                                    <div className="col-sm-9 mt-2">{selectedOrder?.ref1}</div>
                                </div>
                                <div className="mb-2 row">
                                    <label className="col-sm-3 col-form-label">Order No :</label>
                                    <div className="col-sm-9 mt-2">{selectedOrder?.ref2}</div>
                                </div>
                                <div className="mb-2 row">
                                    <label className="col-sm-3 col-form-label">Amount :</label>
                                    <div className="col-sm-9 mt-2">{selectedOrder?.amount.toLocaleString("en-US")}</div>
                                </div>
                                <div className="mb-2 mt-2 row">
                                    <label className="col-sm-3 col-form-label">Type :</label>
                                    <div className="col-sm-9">
                                        <select className="form-select" value={specialStatus} onChange={handleSpecialStatusChange}>
                                            <option value="">Select</option>
                                            <option value="AR">AR Manual</option>
                                            <option value="ARC">AR Auto</option>
                                            <option value="EVC">eVoucher</option>
                                        </select>
                                    </div>
                                </div>
                            </form>
                            <div className="mb-3">
                                <p className="mt-4 mb-6">
                                    <span className={errorSpecialStatusMessageClass}>{errorSpecialStatusMessage}</span>
                                </p>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-dark" data-bs-dismiss="modal" onClick={searchSubmit.bind(this, currentPage)}>Close</button>
                            {isSpecialStatusSaving ?
                                <button className="btn btn-primary" style={{ width: '120px' }} type="button">
                                    <span className="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                    <span className="ms-3">Save</span>
                                </button>
                                : !isSpecialStatusSaveCompleted &&
                                <button type="button" className="btn btn-primary" style={{ width: '120px' }} onClick={onSpecialStatusSave.bind(this)}>
                                    <i className="bi bi-floppy"></i> Save
                                </button>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}